function Route(id) {
  return '/property/' + id;
}

export default Route;
